import React, { Fragment, useEffect, useState } from "react";
import { ticketColumn } from "Constants/TableColumns";
import Translator from "Languages/Utility/Translator";
import RemoteTable from "Components/RemoteTable/RemoteTable";
import { read } from "Helpers/LocalStorage";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import StatusHandler from "Helpers/StatusHandler";
import TicketsService from "Services/http/endpoints/tickets/TicketsService";
import { useDispatch, useSelector } from "react-redux";
import { GETAGAINTICKET } from "Stores/actionTypes";

function TicketsTable() {
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [tblData, setTblData] = useState([]);
  const { getAllTicketAgain } = useSelector((state) => ({
    getAllTicketAgain: state.ticketing.getAllTicketAgain,
  }));

  const onTableChange = async (type, { page, sizePerPage }) => {
    if (type === "pagination") {
      const params = {
        keyGroup: read("groupKey"),
        keyUser: read("userKey"),
        Limit: sizePerPage,
        Page: page,
        sIdForm: 0,
        sAction: 0,
      };
      await getData(params);
      setCurrentPage(page);
      setSizePerPage(sizePerPage);
    }
  };

  const getData = async (params) => {
    try {
      setLoading(true);
      const response = await TicketsService.getTickets(params);
      const err = StatusHandler(response);
      if (!err.isFail) {
        setTblData(
          response.data.Value.map((items, index) => {
            return { ...items, num: index + 1 };
          }),
        );
        setCurrentPage(response.data.Pagination.Page);
        setSizePerPage(response.data.Pagination.Limit);
        setTotal(response.data.Pagination.Total);
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  useEffect(() => {
    (async () => {
      const params = {
        keyGroup: read("groupKey"),
        keyUser: read("userKey"),
        Limit: sizePerPage,
        Page: currentPage,
        sIdForm: 0,
        sAction: 0,
      };
      await getData(params);
    })();
  }, []);

  useEffect(() => {
    (async () => {
      if (getAllTicketAgain) {
        dispatch({ type: GETAGAINTICKET, data: false });
        const params = {
          keyGroup: read("groupKey"),
          keyUser: read("userKey"),
          Limit: sizePerPage,
          Page: currentPage,
          sIdForm: 0,
          sAction: 0,
        };
        await getData(params);
      }
    })();
  }, [getAllTicketAgain]);

  return (
    <Fragment>
      <BackDropLoading loading={loading} />
      <RemoteTable
        data={tblData}
        columns={ticketColumn}
        loading={loading}
        page={currentPage}
        sizePerPage={sizePerPage}
        totalSize={total}
        onTableChange={onTableChange}
        title={<Translator id="tickets_list" />}
      />
    </Fragment>
  );
}

export default TicketsTable;
